// extracted by mini-css-extract-plugin
export default {"online-label":"OnlineLabel_online-label__5Te65","online-label--online":"OnlineLabel_online-label--online__4KLdD"};